import React from 'react';
import ReactDOM from 'react-dom';
import App from './COMPONENTS/App'

ReactDOM.render(
    <App/>  
  ,document.getElementById('root')
);
